"use client";

import { c as _c } from "react/compiler-runtime";
import { COMPANY_INFO } from "@/info/company";
import { CheckCircle, Copy } from "lucide-react";
import { useState } from "react";
import { Heading, Text } from "react-aria-components";
import { ButtonActions } from "./action-buttons";
import { useFormContext } from "./context/FormProvider";
interface StepSuccessProps {
  onBack: () => void;
}
export function StepSuccess(t0) {
  const $ = _c(52);
  const {
    onBack
  } = t0;
  const {
    state
  } = useFormContext();
  const relationship = state.profile?.relationship;
  const [, setWantsLegalVerification] = useState(false);
  const [copied, setCopied] = useState(false);
  const investorUrl = `${COMPANY_INFO.website}/groups/${"GRP123456"}?process=investor-project`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      try {
        await navigator.clipboard.writeText(investorUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {}
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const copyToClipboard = t1;
  if (["builder", "landowner", "investor"].includes(relationship || "")) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex justify-center mb-8"><div className="relative"><div className="w-32 h-32 rounded-full border-4 border-green-500 bg-green-50 flex items-center justify-center"><div className="text-center"><div className="text-3xl font-bold text-green-600 mb-1">DONE</div><CheckCircle className="w-8 h-8 text-green-600 mx-auto" /></div></div></div></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Heading className="text-2xl font-semibold text-gray-900 mb-4">Your Project Has Been Successfully Registered!</Heading>;
      t4 = <Text className="text-gray-600 mb-6">Thank you for trusting us with your investment project. We have created a dedicated group for your project.</Text>;
      $[2] = t3;
      $[3] = t4;
    } else {
      t3 = $[2];
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Text className="text-gray-800 font-medium mb-4">Your Project Group URL:</Text>;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <code className="text-sm text-blue-600 break-all mr-4">{investorUrl}</code>;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Copy className="w-4 h-4" />;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    const t8 = copied ? "Copied!" : "Copy";
    let t9;
    if ($[7] !== t8) {
      t9 = <div className="bg-white border border-blue-200 rounded-lg p-4 flex items-center justify-between">{t6}<button onClick={copyToClipboard} className="flex items-center gap-2 bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors text-sm whitespace-nowrap">{t7}{t8}</button></div>;
      $[7] = t8;
      $[8] = t9;
    } else {
      t9 = $[8];
    }
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Text className="text-sm text-gray-600 mt-3">Share this URL with potential buyers and partners. Group ID: <strong>{"GRP123456"}</strong></Text>;
      $[9] = t10;
    } else {
      t10 = $[9];
    }
    let t11;
    if ($[10] !== t9) {
      t11 = <div className="bg-blue-50 rounded-lg p-6 mb-6">{t5}{t9}{t10}</div>;
      $[10] = t9;
      $[11] = t11;
    } else {
      t11 = $[11];
    }
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Text className="text-gray-700 font-medium mb-3">Project Summary:</Text>;
      $[12] = t12;
    } else {
      t12 = $[12];
    }
    let t13;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <span>Project Name:</span>;
      $[13] = t13;
    } else {
      t13 = $[13];
    }
    const t14 = state.builderOrLandownerOrInvestorProject?.projectName || "N/A";
    let t15;
    if ($[14] !== t14) {
      t15 = <div className="flex justify-between">{t13}<span className="font-medium">{t14}</span></div>;
      $[14] = t14;
      $[15] = t15;
    } else {
      t15 = $[15];
    }
    let t16;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <span>Total Flats:</span>;
      $[16] = t16;
    } else {
      t16 = $[16];
    }
    const t17 = state.builderOrLandownerOrInvestorProject?.totalFlats || "N/A";
    let t18;
    if ($[17] !== t17) {
      t18 = <div className="flex justify-between">{t16}<span className="font-medium">{t17}</span></div>;
      $[17] = t17;
      $[18] = t18;
    } else {
      t18 = $[18];
    }
    let t19;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <span>Flats for Sale:</span>;
      $[19] = t19;
    } else {
      t19 = $[19];
    }
    const t20 = state.builderOrLandownerOrInvestorProject?.noOfFlatsForSale || "N/A";
    let t21;
    if ($[20] !== t20) {
      t21 = <div className="flex justify-between">{t19}<span className="font-medium">{t20}</span></div>;
      $[20] = t20;
      $[21] = t21;
    } else {
      t21 = $[21];
    }
    let t22;
    if ($[22] !== t15 || $[23] !== t18 || $[24] !== t21) {
      t22 = <div className="text-left max-w-md mx-auto bg-gray-50 rounded-lg p-4">{t12}<div className="space-y-2 text-sm text-gray-700">{t15}{t18}{t21}</div></div>;
      $[22] = t15;
      $[23] = t18;
      $[24] = t21;
      $[25] = t22;
    } else {
      t22 = $[25];
    }
    let t23;
    if ($[26] !== t11 || $[27] !== t22) {
      t23 = <div className="text-center mb-8">{t3}{t4}{t11}{t22}</div>;
      $[26] = t11;
      $[27] = t22;
      $[28] = t23;
    } else {
      t23 = $[28];
    }
    let t24;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <Text className="text-green-800 font-medium mb-4">What happens next:</Text>;
      $[29] = t24;
    } else {
      t24 = $[29];
    }
    let t25;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = <li className="flex items-start"><span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" />Our team will review your project details within 24 hours.</li>;
      $[30] = t25;
    } else {
      t25 = $[30];
    }
    let t26;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <li className="flex items-start"><span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" />We will contact you to finalize the listing and marketing strategy.</li>;
      $[31] = t26;
    } else {
      t26 = $[31];
    }
    let t27;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = <div className="bg-green-50 rounded-lg p-6">{t24}<ul className="space-y-2 text-green-700 text-sm">{t25}{t26}<li className="flex items-start"><span className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" />Your project will be promoted to our network of verified buyers.</li></ul></div>;
      $[32] = t27;
    } else {
      t27 = $[32];
    }
    let t28;
    if ($[33] !== t23) {
      t28 = <div className="bg-white rounded-lg shadow-sm p-8">{t2}{t23}{t27}</div>;
      $[33] = t23;
      $[34] = t28;
    } else {
      t28 = $[34];
    }
    let t29;
    if ($[35] !== onBack) {
      t29 = <div className="mt-6"><ButtonActions onBack={onBack} /></div>;
      $[35] = onBack;
      $[36] = t29;
    } else {
      t29 = $[36];
    }
    let t30;
    if ($[37] !== t28 || $[38] !== t29) {
      t30 = <div className="min-h-screen bg-gray-50"><div className="px-4 py-8 max-w-2xl mx-auto">{t28}{t29}</div></div>;
      $[37] = t28;
      $[38] = t29;
      $[39] = t30;
    } else {
      t30 = $[39];
    }
    return t30;
  }
  let t2;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex justify-center mb-8"><div className="relative"><div className="w-32 h-32 rounded-full border-4 border-green-500 bg-green-50 flex items-center justify-center"><div className="text-center"><div className="text-3xl font-bold text-green-600 mb-1">DONE</div><CheckCircle className="w-8 h-8 text-green-600 mx-auto" /></div></div></div></div>;
    $[40] = t2;
  } else {
    t2 = $[40];
  }
  let t3;
  let t4;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heading className="text-2xl font-semibold text-gray-900 mb-4">Thank you for trusting us!</Heading>;
    t4 = <Text className="text-gray-600">Our visit executive will coordinate with you before the visit.</Text>;
    $[41] = t3;
    $[42] = t4;
  } else {
    t3 = $[41];
    t4 = $[42];
  }
  let t5;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text className="text-gray-700 mb-4">You can expect the following in the visit:</Text>;
    $[43] = t5;
  } else {
    t5 = $[43];
  }
  let t6;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="flex items-start"><span className="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0" />Executive will take photos of the property.</li>;
    $[44] = t6;
  } else {
    t6 = $[44];
  }
  let t7;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li className="flex items-start"><span className="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0" />Review or create the floor plan.</li>;
    $[45] = t7;
  } else {
    t7 = $[45];
  }
  let t8;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="bg-white rounded-lg shadow-sm p-8">{t2}<div className="text-center mb-8">{t3}{t4}<div className="text-left max-w-md mx-auto mt-4">{t5}<ul className="space-y-2 text-gray-700">{t6}{t7}<li className="flex items-start"><span className="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0" />Verify the location and direction of property.</li></ul></div></div></div>;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  let t9;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="w-12 h-12 bg-amber-400 rounded-lg flex items-center justify-center"><svg className="w-6 h-6 text-amber-800" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></div>;
    $[47] = t9;
  } else {
    t9 = $[47];
  }
  let t10;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Text className="text-gray-800 font-medium mb-2">Do you know that legally verified properties sells 20% faster than others.</Text>;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg p-6 my-6"><div className="flex items-center space-x-4">{t9}<div className="flex-1">{t10}{" "}<button onClick={() => setWantsLegalVerification(true)} className="text-blue-600 font-semibold underline hover:text-blue-700">Yes, I want free Legal Verification</button></div></div></div>;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  let t12;
  if ($[50] !== onBack) {
    t12 = <div className="min-h-screen bg-gray-50"><div className="px-4 py-8 max-w-2xl mx-auto">{t8}{t11}<ButtonActions onBack={onBack} /></div></div>;
    $[50] = onBack;
    $[51] = t12;
  } else {
    t12 = $[51];
  }
  return t12;
}